import React from 'react'
import Layout from '../../components/layout/Layout'
import BlockedUsersTable from '../../elements/tables/users/BlockedUsersTable'

export default function BlockedUsers() {
  return (
    <div>
      <Layout>
        <BlockedUsersTable />
      </Layout>
    </div>
  )
}
